import React from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import LoaderFull from "~components/Form/components/LoaderFull";
import useCheckIn from "~fetchs/Roterizacao/useCheckIn";
import { TrashCan, WarningIcon } from "~misc/icons";

const WarningBar = ({
  loading,
  pesquisas,
  clienteFechado,
  manterFechado,
  naoConsomeProdutosBasicos,
  handleFechado,
  handleNaoConsome,
  handleManterFechado,
  handleManterNaoConsome,
  loadingRotaVisita,
}) => {
  const { checkin } = useCheckIn();
  const { parameter: idCliente } = useParams();
  const warningContent = () => {
    if (naoConsomeProdutosBasicos && manterFechado) {
      return (
        <div className="z-30 flex flex-col items-center justify-around w-10/12">
          <div className="flex items-center">
            <p className="text-2xl font-bold text-terciaria relative z-30 inline">
              Cliente permanece não consumindo prods. básicos
            </p>
            <TrashCan className="relative z-30 ml-4" onClick={handleNaoConsome} size={34} />
          </div>

          <span
            className="bg-recusado text-center text-white px-8 py-4 rounded-full cursor-pointer font-bold mt-4 z-30 hover:bg-red-700 transition-all"
            onClick={handleManterNaoConsome}
          >
            {"Cliente permanece não consumindo prods. básicos"}
          </span>
        </div>
      );
    } else if (clienteFechado && manterFechado) {
      return (
        <div className="z-30 flex flex-col  items-center justify-around w-7/12">
          <div className="flex items-center">
            <p className="text-2xl font-bold text-terciaria relative z-30 inline">Cliente fechado</p>
            <TrashCan className="relative z-30 ml-4 inline" onClick={handleFechado} size={34} />
          </div>
          <span
            className="bg-recusado text-center text-white px-8 py-4 rounded-full cursor-pointer font-bold mt-4 z-30 hover:bg-red-700 transition-all"
            onClick={handleManterFechado}
          >
            {"Cliente permanece fechado"}
          </span>
        </div>
      );
    } else if (pesquisas && pesquisas.length === 0) {
      return (
        <>
          <WarningIcon className="relative z-30 mr-4" />
          <p className="text-2xl font-bold text-terciaria relative z-30">Cliente sem pesquisas</p>
        </>
      );
    } else if (naoConsomeProdutosBasicos) {
      return (
        <>
          <p className="text-2xl font-bold text-terciaria relative z-30">
            Cliente permanece não consumindo prods. básicos
          </p>
          <TrashCan className="relative z-30 ml-4" onClick={handleNaoConsome} />
        </>
      );
    } else if (clienteFechado) {
      return (
        <>
          <p className="text-2xl font-bold text-terciaria relative z-30">Cliente fechado</p>
          <TrashCan className="relative z-30 ml-4" onClick={handleFechado} />
        </>
      );
    }
  };

  return (
    !loading && (
      <div className="text-center flex items-center justify-center py-6 px-4 relative mt-8">
        <span className="h-4/5 w-4 bg-quinaria absolute rounded-full -left-2 top-1/2 -translate-y-1/2 z-10" />
        <span className="absolute left-0 right-0 top-0 bottom-0 bg-[#FBEAEA] z-20 rounded-md" />
        {warningContent()}

        {loadingRotaVisita && +idCliente === checkin?.clienteId && (
          <div className="spinner__form xx">
            <LoaderFull />
          </div>
        )}
      </div>
    )
  );
};

WarningBar.propTypes = {
  loading: PropTypes.bool,
  pesquisas: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  clienteFechado: PropTypes.bool,
  manterFechado: PropTypes.bool,
  naoConsomeProdutosBasicos: PropTypes.bool,
  handleFechado: PropTypes.func,
  handleNaoConsome: PropTypes.func,
  handleManterFechado: PropTypes.func,
  handleManterNaoConsome: PropTypes.func,
  loadingRotaVisita: PropTypes.bool,
};

export default WarningBar;
